import { HStack, Text, VStack } from '@genial/components';
import { Button, View } from 'native-base';
import React from 'react';

import { SplitInput } from '../../../BatchTicketInvestLink/components/CustomerOffers/components/SplitInput';

interface ValidateTokenProps {
  inputProps: {
    value: string;
    setValue: React.Dispatch<React.SetStateAction<string>>;
    isError: boolean;
    loadingToken: boolean;
  };
  handleValidateToken: (value: string) => void;
}

export const ContainerMobile: React.FC<ValidateTokenProps> = ({
  inputProps,
  handleValidateToken,
}) => {
  const allInputsFilled = inputProps.value?.toString().length === 6;

  return (
    <View minW="container">
      <VStack p="inline.xxxs" flex={1}>
        <VStack space="inline.xxs" flex={1} justifyContent="center">
          <Text fontSize="xl" variant="semibold" textAlign="center">
            Insira seu token
          </Text>
          <Text fontSize="md" variant="regular">
            Informe abaixo o token que enviamos para o seu WhatsApp.
          </Text>
          <HStack>
            <SplitInput {...inputProps} />
          </HStack>
          <Text fontSize="md" variant="regular" pb="inline.md">
            Caso não tenha recebido um token entre em contato com seu(sua) assessor(a).
          </Text>
        </VStack>

        <Button
          variant="primary"
          isLoading={inputProps.loadingToken}
          spinnerPlacement="end"
          isLoadingText="Validando..."
          mb="inline.nano"
          isDisabled={inputProps.isError || !allInputsFilled || inputProps.loadingToken}
          onPress={() => handleValidateToken(inputProps.value)}
          p="inline.nano"
          minH="inline.sm"
          bg="brand.tertiary.principal"
          borderRadius="100px"
          w="full"
          _text={{
            textTransform: 'uppercase',
            variant: 'semibold',
            fontSize: 'md',
          }}>
          Verificar token
        </Button>
      </VStack>
    </View>
  );
};
